import * as roles from 'core/model/roles';
import { StaticRoutes as CoreStaticRoutes } from 'core/model/routes';

const ContentEdit = CoreStaticRoutes.Settings + '/content';
const MessageEdit = CoreStaticRoutes.Settings + '/message';

export const StaticRoutes = {
	ContentEdit,
	MessageEdit,
};

const Content = '/content/:content';

export const DynamicRoutes = {
	Content,
};

export const routes = [
	{
		url: ContentEdit,
		name: 'content',
		role: roles.ADMIN,
		component: 'ContentEdit',
		contextComponent: 'ContentEditSidebar',
	},
	{
		url: MessageEdit,
		name: 'message',
		role: roles.ADMIN,
		component: 'MessageEdit',
	},
	{
		url: Content,
		name: 'content',
		component: 'Content'
	},
];

const combined = {StaticRoutes, DynamicRoutes, routes};

export default combined;
